export function getMonthsArray(month: number): number[] {
    const indexes = [...Array(12).keys()];
    return indexes.slice(month + 1).concat(indexes.slice(0, month + 1));
}
